import type { IconProps } from './icon.types'

const LockIcon = (props: IconProps) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='lock-icon'
    {...props}
  >
    <rect x='3.5' y='8' width='11' height='7' rx='1.2' />
    <path d='M5.5 8V6a3.5 3.5 0 0 1 7 0v2' />
  </svg>
)

export default LockIcon
